import { decode } from 'html-entities';

export const replaceTradeMark = (text: string) => {
    const decodedText = decode(text);
    return decodedText
}